import React, { lazy } from "react";
import { Route, Routes } from "react-router-dom";
import GuestGuard from "src/guard/guest-guard/GuestGuard";
import AuthGuard from "src/guard/auth-guard/AuthGuard";
import AuthLayout from "src/layouts/auth-layout/AuthLayout";
import GuestLayout from "src/layouts/guest-layout/GuestLayout";

const RenderRoutes = () => {
  return (
    <Routes>
      {routes.map((route, index) => {
        const Guard = route.guard;
        const Components = route.component || React.Fragment;
        const Layout = route.layout || React.Fragment;
        return (
          <Route
            key={index}
            path={route.path}
            element={
              <Guard>
                <Layout>
                  <Components />
                </Layout>
              </Guard>
            }
          />
        );
      })}
    </Routes>
  );
};

const routes = [
  {
    path: "/",
    component: lazy(() => import("src/auth/SignIn")),
    guard: GuestGuard,
    layout: GuestLayout,
  },
  {
    path: "/dashboard",
    component: lazy(() => import("src/views/pages/dashboard/Dashboard")),
    guard: AuthGuard,
    layout: AuthLayout,
  },
  {
    path: "/account",
    component: lazy(() => import("src/views/pages/account/index")),
    guard: AuthGuard,
    layout: AuthLayout,
  },
  {
    path: "/account/:bankName",
    component: lazy(
      () => import("src/views/pages/account/index"),
    ),
    guard: AuthGuard,
    layout: AuthLayout,
  },
    {
    path: "/send-money",
    component: lazy(() => import("src/views/pages/send-money/SendMoney")),
    guard: AuthGuard,
    layout: AuthLayout,
  },
    {
    path: "/exchange-money",
    component: lazy(() => import("src/views/pages/exchange-money/ExchangeMoney")),
    guard: AuthGuard,
    layout: AuthLayout,
  },
    {
    path: "/wire-transfer",
    component: lazy(() => import("src/views/pages/wire-transfer/WireTransfer")),
    guard: AuthGuard,
    layout: AuthLayout,
  },
    {
    path: "/request",
    component: lazy(() => import("src/views/pages/requests/Requests")),
    guard: AuthGuard,
    layout: AuthLayout,
  },
    {
    path: "/edit-transaction",
    component: lazy(() => import("src/views/pages/edit-transaction/EditTransaction")),
    guard: AuthGuard,
    layout: AuthLayout,
  },
    {
    path: "/transaction-request",
    component: lazy(() => import("src/views/pages/transaction-request/TransactionRequest")),
    guard: AuthGuard,
    layout: AuthLayout,
  },

];
export default RenderRoutes;
